import type { Resource as ResourceData } from 'src/graphql/types'

import {
  isLinkListResource,
  isLinkResource,
  isMatchmakingSteamCsgoResource,
  isNewResource,
  isSupportedResource,
  isTextResource,
  isVideoResource,
  isWorkshopSteamCsgoResource,
  isYoutubeListResource,
  isYoutubeResource
} from './utils'
import { ResourceText } from './ResourceText'
import { ResourceLink } from './ResourceLink'
import { ResourceLinkList } from './ResourceLinkList'
import { ResourceVideo } from './ResourceVideo'
import { ResourceYoutube } from './ResourceYoutube'
import { ResourceYoutubeList } from './ResourceYoutubeList'
import { ResourceMatchmakingSteamCsgo } from './ResourceMatchmakingSteamCsgo'
import { ResourceWorkshopSteamCsgo } from './ResourceWorkshopSteamCsgo'
import { Resource } from './Resource'

export function ResourceList(props: { resources: ResourceData[] }) {
  const resources = props.resources.filter(isSupportedResource)
  return (
    <div>
      {resources.map((resource, index) => (
        <Resource
          key={resource.id}
          title={resource.title.text}
          isNew={isNewResource(resource)}
          isExclusive={resource.isExclusive}
          isPremium={resource.isPremium}
          isFirst={index === 0}
        >
          <Content resource={resource} />
        </Resource>
      ))}
    </div>
  )
}

function Content(props: { resource: ResourceData }) {
  if (isTextResource(props.resource)) {
    return <ResourceText resource={props.resource} />
  }

  if (isVideoResource(props.resource)) {
    return <ResourceVideo resource={props.resource} />
  }

  if (isYoutubeResource(props.resource)) {
    return <ResourceYoutube resource={props.resource} />
  }

  if (isYoutubeListResource(props.resource)) {
    return <ResourceYoutubeList resource={props.resource} />
  }

  if (isLinkResource(props.resource)) {
    return <ResourceLink resource={props.resource} />
  }

  if (isLinkListResource(props.resource)) {
    return <ResourceLinkList resource={props.resource} />
  }

  if (isMatchmakingSteamCsgoResource(props.resource)) {
    return <ResourceMatchmakingSteamCsgo resource={props.resource} />
  }

  if (isWorkshopSteamCsgoResource(props.resource)) {
    return <ResourceWorkshopSteamCsgo resource={props.resource} />
  }

  // Unreachable after the isSupportedResource filter; a format this build
  // can't render shows nothing rather than throwing.
  return null
}
